import * as React from "react";
import PropTypes from "prop-types";
import ColorPicker from "../../ColorPicker";
import Section from "../../Section";

export default class ColorPickerField extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    ranges: PropTypes.arrayOf(
      PropTypes.oneOf(["warm", "cool", "red", "green", "blue"])
    ).isRequired,
    bulb: PropTypes.bool,
    warm: PropTypes.number,
    cool: PropTypes.number,
    red: PropTypes.number,
    green: PropTypes.number,
    blue: PropTypes.number,
    onChange: PropTypes.func,
  };

  handleDragEnd = (colors) => {
    if (this.props.onChange) {
      this.props.onChange(colors);
    }
  };

  render() {
    const { label, warm, cool, red, green, blue, bulb, ranges } = this.props;

    const rangesMap = ranges.reduce((obj, item) => {
      obj[item] = true;
      return obj;
    }, {});

    return (
      <Section label={label}>
        <ColorPicker
          warm={warm}
          cool={cool}
          red={red}
          green={green}
          blue={blue}
          bulb={bulb}
          showRGB={rangesMap.red || rangesMap.green || rangesMap.blue}
          showWarmCool={rangesMap.warm || rangesMap.cool}
          onDragEnd={this.handleDragEnd}
        />
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/ColorPickerField.jsx